var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "callout__extended",
      attrs: { controlled: true, opened: _vm.value.isOpened },
      on: { "click:open": _vm.onOpenDetails },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              !_vm.value.isOpenDenyPayment
                ? _c("div", { staticClass: "bg-gray p-2" }, [
                    _c(
                      "div",
                      { staticClass: "bg-white rounded" },
                      [
                        _c(
                          "custom-tab",
                          {
                            attrs: {
                              "content-class": "mt-5",
                              "nav-class": "custom-nav-container",
                              "no-nav-style": true
                            },
                            model: {
                              value: _vm.value.mainTabModel,
                              callback: function($$v) {
                                _vm.$set(_vm.value, "mainTabModel", $$v)
                              },
                              expression: "value.mainTabModel"
                            }
                          },
                          [
                            _c(
                              "custom-tab-item",
                              {
                                attrs: {
                                  active: "",
                                  lazy: "",
                                  title: "Información Adicional"
                                }
                              },
                              [
                                _c("additional-info", {
                                  attrs: {
                                    "is-thrpy-service": _vm.isTherapyService(
                                      _vm.value.peiAnalysisServiceId
                                    ),
                                    "thrpy-info": _vm.thrpyInfo || {},
                                    "transportation-info":
                                      _vm.transportationInfo || {},
                                    value: _vm.value
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.getAssistanceTherapyTransportationInfo(
                                        _vm.value
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "custom-tab-item",
                              {
                                attrs: {
                                  active:
                                    _vm.mainTabsEnum.ASSISTANCE_DETAILS ===
                                    _vm.value.mainTabModel,
                                  lazy: "",
                                  title: "Detalles de Asistencia"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onSelectTabAssistanceDetails(
                                      _vm.index,
                                      _vm.value
                                    )
                                  }
                                }
                              },
                              [
                                _c("assistance-details", {
                                  attrs: {
                                    "adjust-assistances":
                                      _vm.value.adjustAssistances,
                                    "adjust-periods": _vm.value.adjustPeriods,
                                    "assistance-service":
                                      _vm.value.assistanceService,
                                    "assistance-summary": _vm.value,
                                    "normal-assistances":
                                      _vm.value.normalAssistances,
                                    "selected-period": _vm.value.selectedPeriod,
                                    "show-assistance-service": _vm.showAssistanceService(
                                      _vm.value
                                    )
                                  }
                                }),
                                _vm.showAssistanceVisit(
                                  _vm.value.payrollReceiveTypeId
                                )
                                  ? _c("assistance-visit", {
                                      attrs: {
                                        rows: _vm.value.assistanceVisitResult
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "custom-tab-item",
                              {
                                attrs: {
                                  active:
                                    _vm.mainTabsEnum.PAYMENTS ===
                                    _vm.value.mainTabModel,
                                  lazy: "",
                                  title: "Pagos"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onSelectTabPayment(_vm.value)
                                  }
                                }
                              },
                              [
                                _c("payment", {
                                  attrs: {
                                    "additional-payments":
                                      _vm.payment.additionalPayments || [],
                                    "payment-relationship":
                                      _vm.payment.relationshipPayments,
                                    status: 1,
                                    value: _vm.payment.payment || {}
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "custom-tab-item",
                              {
                                attrs: {
                                  active:
                                    _vm.mainTabsEnum.HISTORY ===
                                    _vm.value.mainTabModel,
                                  lazy: "",
                                  title: "Historial"
                                }
                              },
                              [
                                _c("history", {
                                  staticClass: "mt-2",
                                  attrs: { id: _vm.value.assistanceSummaryId }
                                })
                              ],
                              1
                            ),
                            _c(
                              "custom-tab-item",
                              {
                                attrs: {
                                  lazy: "",
                                  title: "Informe de Progreso"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onSelectTabProgressReport(
                                      _vm.value
                                    )
                                  }
                                }
                              },
                              [
                                _c("progress-inform", {
                                  attrs: {
                                    value: _vm.value.progressReport || {}
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.value.isOpenDenyPayment
                ? _c("div", { staticClass: "bg-gray p-2" }, [
                    _c(
                      "div",
                      { staticClass: "bg-white rounded" },
                      [
                        _c("deny-payment", {
                          attrs: { value: _vm.value },
                          on: {
                            "on-cancel": _vm.onCleanDenySection,
                            "on-confirm": _vm.onDenegateHandler
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "row mt-4" }, [
              _c("div", { staticClass: "col-2 col-sm col-6" }, [
                _c(
                  "div",
                  { staticClass: "color-black font-14 font-weight-bold" },
                  [_vm._v(" " + _vm._s(_vm.value.serviceTypeMainName) + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "color-black font-weight-normal font-16" },
                  [_vm._v(" " + _vm._s(_vm.value.serviceTypeName) + " ")]
                )
              ]),
              _c(
                "div",
                { staticClass: "col-1 col-sm col-6 d-sm-block d-md-none" },
                [
                  _c("check-box", {
                    staticClass: "pl-5",
                    model: {
                      value: _vm.value.checked,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "checked", $$v)
                      },
                      expression: "value.checked"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Estudiante: ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "color-black font-weight-bold font-16" },
                    [_vm._v(" " + _vm._s(_vm.value.studentFullName) + " ")]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" SIE: ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "color-black font-weight-bold font-16" },
                    [_vm._v(" " + _vm._s(_vm.value.studentSieId) + " ")]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Periodo: ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "color-black font-weight-bold font-16" },
                    [_vm._v(" " + _vm._s(_vm.value.period) + " ")]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-2 col-sm col-6 mt-3 mt-md-0 mt-sm-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-secondary-6 font-14 font-weight-normal"
                    },
                    [_vm._v(" Costo: ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "color-black font-weight-bold font-16" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("price")(_vm.value.costTotalAmt)) +
                          " "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-md-2 col-sm-12" },
                [
                  _vm.canDenyPayment
                    ? _c(
                        "action-button",
                        {
                          staticClass:
                            "outline-danger btn-cancel danger px-3 mr-2",
                          attrs: {
                            id: "btnCancel",
                            i: "fas fa-times-circle",
                            variant:
                              "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                          },
                          on: { click: _vm.onOpenCloseSection }
                        },
                        [_vm._v(" Cancelar ")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-1 col-sm-12 d-md-block d-sm-none" },
                [
                  _c("check-box", {
                    staticClass: "pl-5",
                    model: {
                      value: _vm.value.isChecked,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "isChecked", $$v)
                      },
                      expression: "value.isChecked"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "col-1",
              staticStyle: { "max-width": "70px !important" }
            },
            [
              _c("compact-nav-tabs", {
                attrs: { value: _vm.generalTabIndex },
                on: {
                  "on-select-tab-index": function($event) {
                    return _vm.onSelectTabIndexHandler(
                      _vm.index,
                      _vm.value,
                      $event
                    )
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }